import { CaregiversTabs } from './constants';

export const getTabInfo = (caregivers = []) => {
  const activeCaregivers = [];
  const inactiveCaregivers = [];

  [...caregivers]
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    .forEach((caregiver) => {
      if (caregiver.deletedAt) {
        inactiveCaregivers.push(caregiver);
        return;
      }

      activeCaregivers.push(caregiver);
    });

  const tabInfo = {
    ACTIVE: {
      text: CaregiversTabs.ACTIVE.text,
      count: activeCaregivers.length,
    },
    NOT_ACTIVE: {
      text: CaregiversTabs.NOT_ACTIVE.text,
      count: inactiveCaregivers.length,
    },
    ALL: {
      text: CaregiversTabs.ALL.text,
      count: caregivers.length,
    },
  };

  return {
    tabInfo,
    activeCaregivers,
    inactiveCaregivers,
    allCaregivers: caregivers,
  };
};
